import React, { useEffect } from 'react';
import { Box, Link } from '@mos-cat/ds';

import OutageBlock from '../common/OutageBlock';
import { toFriendlyPhoneFormat, toSimplePhoneFormat } from '../../../../helpers/phone';
import { STATS_EVENTS, sendStats } from '../../../../helpers/sendStats';

// typograf-enable
export default function EmptyOutageInfo() {
  const phone = '+7 495 539-59-59';
  const unformattedPhone = toSimplePhoneFormat(phone);
  const formattedPhone = toFriendlyPhoneFormat(phone);

  useEffect(function sendStatsOnMount() {
    sendStats(STATS_EVENTS.EMPTY_OUTAGE_INFO);
  }, []);

  const handlePhoneClick = () => {
    sendStats(STATS_EVENTS.LINK_CLICK, 'Телефон МОЭК');
  };

  const handleLinkClick = () => {
    sendStats(STATS_EVENTS.LINK_CLICK, 'Дома Москвы');
  };

  return (
    <OutageBlock heading="По данному адресу нет информации об отключении горячей воды">
      <Box mt="sp-8">
        Для уточнения графика профилактических работ в доме вы можете обратиться в ПАО «МОЭК» по
        телефону{' '}
        <Link
          href={`tel:${unformattedPhone}`}
          onClick={handlePhoneClick}
          styles={{ whiteSpace: 'nowrap' }}
        >
          {formattedPhone}
        </Link>{' '}
        или в свою управляющую компанию — контакты можно найти на сайте{' '}
        <Link href="https://dom.mos.ru/" target="_blank" onClick={handleLinkClick}>
          «Дома Москвы»
        </Link>
        .
      </Box>
    </OutageBlock>
  );
}
